<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Add puzzle image</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Image *</label>
                  <div class="col-md-10">
                    <image-uploader
                      ref="uploader"
                      :uploaded-img-url="source.image ? source.image.public_url : null"
                      :removable="false"
                      @changeFile="coverChange"
                    />
                  </div>
                </div>
                <template v-if="imageLoaded">
                  <div v-for="preset in presets" :key="preset.id" class="form-group row">
                    <label class="col-md-2" :for="preset.type">{{ preset.title }}</label>
                    <div class="col-md-10">
                      <select :id="`${preset.type}*`" v-model="entity.levels[preset.type]" class="form-control">
                        <option v-for="(item, key) in makeOptions(preset)" :key="key" :value="item">
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2" for="default">Default</label>
                    <div class="col-md-10">
                      <select id="default" v-model="entity.default_level" class="form-control">
                        <option v-for="(preset, key) in presets" :key="key" :value="preset.type">
                          {{ preset.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                </template>
                <template v-for="(quote, key) in entity.quotes">
                  <PuzzleQuote
                    :key="key"
                    :quote="quote"
                    :number="key"
                    @deleteQuote="onDeleteQuote"
                  />
                </template>
                <button class="btn btn-success" @click="addQuote">
                  Add Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Puzzle image has added successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import PuzzleGameMixin from '@/mixins/PuzzleGameMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import PuzzleQuote from './PuzzleQuote.vue';

export default {
  name: 'PuzzleImageNew',

  components: {
    PuzzleQuote,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests, PuzzleGameMixin],

  methods: {
    isEntityValid() {
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
      ];
      return this.$_validate(filelds);
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('levels', JSON.stringify(this.entity.levels));
      if (this.entity.quotes.length) {
        postFormData.append('quotes', JSON.stringify(this.entity.quotes));
      }
      postFormData.append('puzzle', this.entity.image);
      postFormData.append('default_level', this.entity.default_level);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/puzzles`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/puzzle-game-images/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    coverChange(file) {
      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = () => {
          this.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.image = file;
        return;
      }
      this.imageSelected = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?3dfb9df4